import { Component } from "preact";
import '../style/window.css';
import StartForm from "./start-form";
import Chat from "./chat";
import ResumeMismatchForm from "./resume-mismatch-form";
import socket from "../helper/socket";
import sessionCache from "../helper/session-cache";
import MessagePropagator from "../helper/message-propagator";
import { ConfigContext } from '../contexts/config';

export default class Window extends Component {
    constructor(props) {
        super(props);

        this.state = {
            innerLoading: false,
            enableChat: false,
            showResumeMismatch: false,
        }

        if (props.resumeChat) {
            // shard id in cache mismatches the one from props, show mismatch form
            if (props.shard !== sessionCache.getShard()) {
                this.state.showResumeMismatch = true;
            } else {
                // resumeChat is true, there is no mismatch, enable chat
                this.state.enableChat = true;
            }
        }
    }

    onClose() {
        this.props.onClose();
    }

    handleStartFormSubmit(data) {
        data = {
            ...data,
            shard: this.props.shard,
            tenantId: this.props.tenant,
            tenantRel: sessionCache.getTenantRel()
        };

        this.setState({
            innerLoading: true
        });

        MessagePropagator.postStartFormSubmit(data.name, data.mail);

        socket.announce(data, (sessionId) => {
            // Always clearing session cache for good measure
            sessionCache.clear();
            if (sessionId !== null) {
                sessionCache.setSessionId(sessionId);
                sessionCache.setShard(this.props.shard);
            }

            this.setState({
                innerLoading: false,
                enableChat: true,
            });
        })
    }

    handleResumeMismatchFormDecision(decision) {
        if (decision === 1) {
            // Keep old chat
            this.setState({
                showResumeMismatch: false,
                enableChat: true
            })
        } else if (decision === 0) {
            // Start new chat: show start form
            this.setState({
                showResumeMismatch: false,
                enableChat: false
            })
        }
    }

    render() {
        const wrapperStyle = {
            width: this.props.width + 'px',
            height: this.props.height + 'px',
            maxHeight: '100%',
            maxWidth: '100%',
        };

        if (!this.props.show) {
            wrapperStyle.display = 'none';
        }

        let inner;

        if (this.state.showResumeMismatch) {
            inner = <ResumeMismatchForm onDecision={this.handleResumeMismatchFormDecision.bind(this)} />
        } else if (this.state.enableChat) {
            inner = <Chat/>;
        } else {
            inner = <StartForm disableAll={this.state.innerLoading} onSubmit={this.handleStartFormSubmit.bind(this)} />;
        }

        return (
            <ConfigContext.Consumer>
                {config => (
                    <div style={wrapperStyle}>
                        <div className={'window'}>
                            <div className={'header'}>
                                <div className={'headline'}>{config.getTranslations().windowHeadline}</div>
                                <div onClick={this.onClose.bind(this)} className={'close'} />
                            </div>

                            <div className={'content'}>
                                {inner}
                            </div>
                        </div>
                    </div>
                )}
            </ConfigContext.Consumer>
        )
    }
}